import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'nx-ng-not-implemented',
  templateUrl: './not-implemented.component.html',
  styleUrls: ['./not-implemented.component.scss']
})
export class NotImplementedComponent implements OnInit {

  @Input()
  name = "I'm";

  @Input()
  data = "";

  myRoute: string | undefined;

  constructor(
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.myRoute = this.route.pathFromRoot.join(" ");
  }

}
